import * as React from "react";
import clx from "clsx";
import {
  textFieldAddon,
  textFieldAddonSizes,
  textFieldAddonPositions,
  textFieldAddonDivider,
} from "./text-field-addon.css";
import type { TextFieldAddonProps } from "./text-field-addon.types";

function TextFieldAddon(props: TextFieldAddonProps) {
  return (
    <div
      className={clx(
        textFieldAddon,
        textFieldAddonSizes[props.size],
        textFieldAddonPositions[props.position],
        props.divider ? textFieldAddonDivider[props.position] : null,
        props.className
      )}
    >
      {props.children}
    </div>
  );
}

TextFieldAddon.defaultProps = {
  divider: false,
  intent: "default",
  disabled: false,
};

export default TextFieldAddon;
